import React from 'react';
import { useHistory } from 'react-router-dom';
import moment from 'moment';
import { useStoreState, useStoreActions } from 'easy-peasy';
import {
  // makeStyles,
  Grid,
  Button,
  Box,
  Typography, FormControl, FormHelperText,
  Dialog,
  DialogContent
} from '@material-ui/core';
import * as Yup from 'yup';
import { Formik, Field } from 'formik';
import styles from './reportAdd.module.scss';
import RenderField from './RenderField';
import { stringConstants } from '../../constants/stringConstants';
// import DisplayBreadcrumbs from '../../components/displayBreadcrumbs/displayBreadcrumbs';
/** STYLES HERE * */
// const useStyles = makeStyles((theme) => ({
//   formControl: {
//     margin: theme.spacing(2),
//     marginLeft: '0px',
//     width: 'calc(100% - 32px)',
//   },
//   mainPadding: {
//     padding: '0 20px',
//   },
//   attachFile: {
//     paddingTop: '30px !important',
//   }
// }));
// dynamic field filter
const FieldCommon = (props) => {
  const businessLineList = useStoreState((state) => state.businessLine?.businessLineList);
  const programList = useStoreState((state) => state.programs?.programList);
  let collectionType = [];
  let collectionTitle = '';

  if (props.dataCollectionType == 'businesslines') {
    collectionTitle = 'Business Line List'
    collectionType = businessLineList?.map((element)=>{
      return { title: element.title, PK: element.title }
    });

    return (<Field name={props.name} title={collectionTitle} data={collectionType} type="multi-select-with-all-option" component={RenderField} />);
  }


  if (props.dataCollectionType == 'programs') {
    collectionTitle = 'Programs'
    collectionType = programList?.map((element)=>{
      return { title: element.title, PK: element.title }
    });

    return (<Field name={props.name} title={collectionTitle} data={collectionType} type="multi-select-with-all-option" component={RenderField} />);
  }
}

const StandardReportFilter = (props) => {
  const { 
    onCloseDialog,
    currentRowPK,
    ...other
  } = props;
  const history = useHistory();
  const reportAction = useStoreActions((actions) => actions.report);
  const reportState = useStoreState((state) => state.report);
  // const { history } = props;
  //const commonAction = useStoreActions((actions) => actions.common);
  const businessLineAction = useStoreActions((actions) => actions.businessLine);
  const programAction = useStoreActions((actions) => actions.programs);


  // const classes = useStyles();

  // Validation Schema for formik
  const schema = Yup.object().shape({
    entity: Yup.string().required(stringConstants.requiredValidationMsg),
    from_date: Yup.date().required(stringConstants.requiredValidationMsg),
    // to_date: Yup.string().required(stringConstants.requiredValidationMsg)
    to_date: Yup
      .date()
      .when('from_date', (from_date, schema) => {
        if (from_date && from_date != 'Invalid Date') {
          return schema
            .min(from_date, 'To date should not be less than from date');
        } else {
          return schema;
        }
      })
      .required(stringConstants.requiredValidationMsg),
  });

  const onFormSubmit = async (values, { resetForm, setErrors }) => {
    let query = '';
    if(values.entity && values.entity.length>0){
        query += `entity=${encodeURIComponent(values.entity.map(obj=> obj.title).toString())}&`;
    }
    if(values.from_date && values.entity.length>0){
        query += `from_date=${moment(values.from_date).format('YYYY-MM-DD')}&`;
    }
    if(values.to_date && values.entity.length>0){
        query += `to_date=${moment(values.to_date).format('YYYY-MM-DD')}&`;
    }

    query = query.length>0?query.substr(0,query.length-1):'';
    reportAction.setReportresultList([]);
    history.push(`/reportresult/custom-standard/${encodeURIComponent(currentRowPK)}?${query}`);
  };

  React.useEffect(() => {
    //get line of Business
    businessLineAction.getBusinessLineList('purpose=listing');
    //get program
    programAction.getProgramList('purpose=listing');
    // if (props.match && props.match.params.id) {
    //   reportAction
    //     .getStandardReport(props.match.params.id).then(function (response) {
    //       if(response.payload && response.payload.error){
    //         setEmptyRecord(true)
    //       }
    //     });
    // }
    if (currentRowPK) {
      reportAction
        .getStandardReport(encodeURIComponent(currentRowPK)).then(function (response) {
          if(response.payload && response.payload.error){
            setEmptyRecord(true)
          }
        });
    }
  }, []);

  return (
    <Dialog
      disableBackdropClick
      disableEscapeKeyDown
      maxWidth="md"
      aria-labelledby="confirmation-dialog-title"
      open={open}
      {...other}
      PaperProps={{
        style: { borderRadius: 20, maxWidth: '800px' }
      }}
    >
      <Grid container direction="column">
        {/* <Grid item md={12} xs={12}>         
          <DisplayBreadcrumbs items={[{ title: "Standard Reports", link: "/reports/standard" }, { title: "Standard Report Execute", link: "" }]} />
        </Grid> */}
        <Formik
        initialValues ={{entity:'', from_date:'', to_date:''}}
          onSubmit={onFormSubmit}
          validationSchema={schema}
          enableReinitialize={true}
        >
          {(propsFormik) => {
            const {
              errors,
              setFieldValue,
              handleSubmit,
              resetForm,
            } = propsFormik;
            return (
              <Box className={styles.dialogmainwrapper}>
                <form onSubmit={handleSubmit} noValidate>
                  <DialogContent>
                    <Grid container spacing={2}>
                      <Grid item md={8} xs={12}>
                        <Typography variant="h6" component="h6">Apply Filter</Typography>
                      </Grid>
                      <Grid item md={9} xs={12}>
                        <FormControl variant="outlined" fullWidth>
                          {/* {reportState.standardReport.query==='PROGRAM_PROCEDURES_CONFIGURABLE' && (<FieldCommon name={`entity`} dataCollectionType={'programs'} />)}
                          {reportState.standardReport.query==='POLICIES_PROCEDURES_BY_LOB_CONFIGURABLE' && (<FieldCommon name={`entity`} dataCollectionType={'businesslines'} />)} */}
                          <FieldCommon name={`entity`} dataCollectionType={reportState.standardReport && reportState.standardReport.query === 'PROGRAM_PROCEDURES_CONFIGURABLE' ? 'programs' : 'businesslines'} />
                          <FormHelperText
                              className={
                              errors.entity? 'Mui-error'
                                  : ''
                              }
                          >
                            {errors.entity}
                          </FormHelperText>
                        </FormControl>
                      </Grid>
                      <Grid item md={6} xs={12}>
                        <FormControl variant="outlined" fullWidth>
                          <Field name={`from_date`} range={true} type={'date'} title={'From Date'} component={RenderField} />
                          <FormHelperText
                            className={
                              errors.from_date? 'Mui-error'
                                : ''
                              }
                            >
                            {errors.from_date}
                          </FormHelperText>
                        </FormControl>
                      </Grid>
                      <Grid item md={6} xs={12}>
                        <FormControl variant="outlined" fullWidth>
                          <Field name={`to_date`} range={true} type={'date'} title={'To Date'} component={RenderField} />
                          <FormHelperText
                            className={
                            errors.to_date ? 'Mui-error'
                                : ''
                            }
                          >
                            {errors.to_date}
                          </FormHelperText>
                        </FormControl>
                      </Grid>
                    </Grid>
                    <Grid
                      container
                      direction="row"
                      justifyContent="center"
                      alignItems="center"
                      spacing={2}
                      className={styles.btns}
                    >
                      <Grid item>
                        <Button
                          onClick={() => {
                            resetForm();
                            onCloseDialog();
                          }}
                          variant="contained"
                          color="secondary"
                        >
                          Cancel
                        </Button>
                      </Grid>
                      <Grid item>
                        <Button
                          type="submit"
                          variant="contained"
                          color="primary"
                          onClick={(e) => {
                            setFieldValue('isSavePreview', false)
                            handleSubmit(e);
                          }}
                        >
                          Execute
                        </Button>
                      </Grid>
                    </Grid>
                  </DialogContent>
                </form>
              </Box>
            );
          }}
        </Formik>
      </Grid>
    </Dialog>
  );
};

export default StandardReportFilter;
